/**
 * Aniwell image + FAQ section (sections/aniwell-image-faq.liquid).
 * Expands/collapses answers; optional single-open mode via data-single="true".
 */
(() => {
  'use strict';

  const setOpen = (item, open) => {
    item.classList.toggle('is-open', open);
    const btn = item.querySelector('[data-aw-faq-q]');
    if (btn) btn.setAttribute('aria-expanded', open);
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-aw-faq]').forEach((list) => {
      if (list.dataset.awReady) return;
      list.dataset.awReady = 'true';
      list.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-aw-faq-q]');
        if (!btn || !list.contains(btn)) return;
        const item = btn.closest('[data-aw-faq-item]');
        const open = !item.classList.contains('is-open');
        if (open && list.dataset.single === 'true') {
          list.querySelectorAll('[data-aw-faq-item].is-open').forEach((other) => setOpen(other, false));
        }
        setOpen(item, open);
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  // Theme editor: open the question being edited.
  document.addEventListener('shopify:block:select', (e) => {
    if (e.target.matches && e.target.matches('[data-aw-faq-item]')) setOpen(e.target, true);
  });
})();
